import './accounts.css';
import { Link } from 'react-router-dom';
import { fmtDate, initials } from '../../lib/format';
import { useRegistrations } from './useRegistrations';

// Karte „Neue Registrierungen“ (nur Admin, nur wenn welche warten). Älteste zuerst.
export function RegistrationCard() {
  const regs = useRegistrations();
  const open = regs.data?.open ?? [];
  if (!open.length) return null;
  return (
    <section className="card regcard acc" aria-labelledby="regcard-h">
      <div className="ch">
        <h3 id="regcard-h">Neue Registrierungen</h3>
        <span>{open.length === 1 ? '1 wartet auf Freigabe' : `${open.length} warten auf Freigabe`}</span>
      </div>
      {open.map((g) => (
        <div className="task" key={g.id}>
          <span className="av" aria-hidden="true">
            {initials(g.name)}
          </span>
          <div className="tx">
            <b>{g.name}</b>
            <small>
              {g.contactName} · {[g.zip, g.city].filter(Boolean).join(' ')} · registriert am {fmtDate(g.registeredAt)}
            </small>
          </div>
          <Link className="btn sm dark" to={`/kanzlei/registrierungen/${g.id}`} aria-label={`${g.name} prüfen`}>
            Prüfen
          </Link>
        </div>
      ))}
    </section>
  );
}
